// 抽選キャンペーン (LOTTERY) で、再予約完了画面でメールアドレスを登録したお客様に掛ける倍率.
// 例: ルーレットで 3 倍 → メール登録で 3 × 2 = 6 倍.
//
// backend はこの倍率も「登録済みか」も持たない. 当選者選定のときに
// メール登録済み (rh_cancels.email_source = rereservation_form) のくじ券へ倍率を掛ける運用なので、
// FE は訴求の表示にだけこの定数を使う (登録直後の「適用されました」表示は FE の送信状態で切り替える).
export const LOTTERY_EMAIL_BONUS_MULTIPLIER = 2

// メール登録後の倍率.
export const boostLotteryMultiplier = (baseMultiplier: number): number =>
	baseMultiplier * LOTTERY_EMAIL_BONUS_MULTIPLIER
